import * as type from './types';

export function getDashboardData(data) {
    return {
        type: type.GET_DASHBOARD_DATA_REQUESTED,
        data: data,
    }
}